import { Box, Button, Text, VStack } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  isSatelliteView?: boolean;
  onSatelliteClick: () => void;
  onRoadmapClick: () => void;
  onDetailClick?: () => void;
}

const MapButtons: React.FC<React.PropsWithChildren<Props>> = ({
  isSatelliteView,
  onSatelliteClick,
  onRoadmapClick,
  onDetailClick,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      maxW="18rem"
      boxShadow="level3"
      background="white"
      p="4"
      borderRadius="5px"
    >
      <Text textStyle="h6Headline" as="h6" mb="4">
        {t('Type of map')}
      </Text>
      <VStack spacing="2">
        <Button
          w="100%"
          variant={isSatelliteView ? 'solid' : 'outline'}
          onClick={onSatelliteClick}
        >
          {t('Sattelite view')}
        </Button>
        <Button
          w="100%"
          variant={!isSatelliteView ? 'solid' : 'outline'}
          onClick={onRoadmapClick}
        >
          {t('Roadmap')}
        </Button>

        {onDetailClick && (
          <Button
            w="100%"
            variant="link"
            onClick={onDetailClick}
            whiteSpace="initial"
          >
            {t('COMMON_COMPONENTS_STATIC-MAP_MAP-DETAL-VIEW-BUTTON')}
          </Button>
        )}
      </VStack>
    </Box>
  );
};

export default MapButtons;
